module.exports = __webpack_public_path__ + "static/media/1500.6a8c6328.jpg";